import axios from 'axios'
import { config } from './config'
import {store} from "@/store";

const apiUrl = config.$api_url

export default {
    settingsInfo() {
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/settings-info')
            .then(response => response.data)
    },
    saveSettings(data) {
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/save-settings', data)
            .then(response => response.data)
    },
    adminGroups(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/groups', data)
            .then(response => response.data)
    },
    createGroup(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/create-group', data)
            .then(response => response.data)
    },
    removeGroup(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/remove-group', data)
            .then(response => response.data)
    },
    groupDetail(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/group-detail', data)
            .then(response => response.data)
    },
    groupEdit(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/group-edit', data)
            .then(response => response.data)
    },
    admins(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/admins', data)
            .then(response => response.data)
    },
    adminDetail(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/detail-admin', data)
            .then(response => response.data)
    },
    removeAdmin(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/remove-admin', data)
            .then(response => response.data)
    },
    addAdmin(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/add-admin', data)
            .then(response => response.data)
    },
    editAdmin(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/edit-admin', data)
            .then(response => response.data)
    },
    changeAdminStatus(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/change-status-admin', data)
            .then(response => response.data)
    },
    changePassword(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/change-password', data)
            .then(response => response.data)
    },
}